<div class="flex flex-col gap-4 w-full h-full relative text-primary-text">

  @if (title || description) {
  <div class="flex flex-col gap-1 mb-2">
    @if (title) { <h3 class="text-lg font-bold text-heading">{{ title }}</h3> }
    @if (description) { <p class="text-sm text-secondary-text">{{ description }}</p> }
  </div>
  }

  @if (suggestions && suggestions.length > 0) {
  <div class="relative w-full mb-4 group/carousel">
    <nz-carousel #suggestionsCarousel
                 [nzEffect]="'scrollx'"
                 [nzDots]="true"
                 class="w-full pb-6">
      <div nz-carousel-content
           *ngFor="let chunk of suggestionChunks()">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-3 w-full p-1">
          @for (sugg of chunk; track sugg.title) {
          <button (click)="selectSuggestion(sugg)"
                  class="bg-component-inner border border-primary-border rounded-lg p-3 text-left hover:border-primary hover:shadow-default transition-all group flex flex-col items-start gap-1 h-[100px] overflow-hidden focus:outline-none">
            <div class="flex items-center gap-2 mb-1">
              <i class="fad fa-sparkles text-primary opacity-70 group-hover:opacity-100 text-sm"></i>
              <span class="font-bold text-primary-text text-sm">{{ sugg.title }}</span>
            </div>
            <span class="text-xs text-secondary-text line-clamp-2 leading-relaxed">{{ sugg.description }}</span>
          </button>
          }
        </div>
      </div>
    </nz-carousel>
  </div>
  }

  <div
       class="w-full bg-component-inner border border-primary-border rounded-xl p-3 shadow-sm flex flex-col gap-3 focus-within:border-primary transition-all">
    <textarea nz-input
              [nzAutosize]="{ minRows: 4, maxRows: 10 }"
              [ngModel]="promptText()"
              (ngModelChange)="promptText.set($event)"
              [placeholder]="placeholder"
              [disabled]="isSubmitting"
              class="w-full !bg-transparent !border-none !shadow-none !px-2 !py-2 text-base text-primary-text resize-none focus:outline-none custom-scrollbar disabled:opacity-50"></textarea>

    @if (selectedFiles().length > 0) {
    <div class="flex flex-wrap gap-2 px-2 pb-2">
      @for (file of selectedFiles(); track file.name) {
      <div
           class="flex items-center gap-2 bg-alt-background border border-secondary-border rounded-lg px-3 py-1.5 shadow-sm">
        <i [class]="getFileIcon(file.name, file.type) + ' text-sm'"></i>
        <span class="text-xs font-semibold text-primary-text truncate max-w-[150px]"
              [title]="file.name">{{ file.name }}</span>
        <button type="button"
                (click)="removeFile(file)"
                class="text-secondary-text hover:text-danger focus:outline-none flex items-center justify-center p-0.5 ml-1">
          <i class="fas fa-times text-[10px]"></i>
        </button>
      </div>
      }
    </div>
    }

    <div class="flex items-center justify-between border-t border-secondary-border pt-3 px-2">
      <nz-upload [nzBeforeUpload]="beforeUpload"
                 [nzMultiple]="true"
                 [nzShowUploadList]="false"
                 [nzDisabled]="isSubmitting"
                 class="flex-1">
        <button nz-button
                nzType="default"
                [disabled]="isSubmitting"
                class="!bg-alt-background !border-secondary-border !text-secondary-text hover:!text-primary hover:!border-primary flex items-center gap-2 !rounded-md !px-3">
          <i class="fas fa-paperclip"></i> {{ uploadText }}
        </button>
      </nz-upload>
    </div>
  </div>

  <div class="flex items-center justify-end gap-3 mt-2">
    <button nz-button
            nzType="default"
            (click)="onCancel()"
            [disabled]="isSubmitting"
            class="!border-secondary-border !text-secondary-text !bg-button-bg hover:!bg-hover-default">
      {{ cancelText }}
    </button>
    <button nz-button
            nzType="primary"
            (click)="onSubmit()"
            [disabled]="(!allowEmptySubmit && !promptText().trim()) || isSubmitting"
            [nzLoading]="isSubmitting"
            class="!bg-primary !border-primary hover:!bg-hover-primary !text-white font-semibold flex items-center gap-2">
      <i class="fas fa-paper-plane mr-1"></i> {{ submitText }}
    </button>
  </div>

</div>